module.exports = __webpack_public_path__ + "static/img/business-executive-applauding-during-video-conference.6e7b5ba5.jpg";